// How to register a story in DevTools:
// 1) Create a `*.stories.tsx` file next to your component (see examples in shared/*).
//    The file should export a default `StoryMeta<Props>` object with fields like:
//      id: "shared/JSONTable",
//      title: "JSONTable",
//      group: "Shared/Data",
//      component: YourComponent,
//      description: "Short description",
//      defaultProps: { ... },
//      variants: [{ name: "Variant name", props: { ... } }]
// 2) Import that stories file here and add it to the `STORIES` array below.
//    Tip: Keep the id path-like so URLs become `/dev/shared/JSONTable`.
// 3) Visit `/dev/<id>` to load the story. Use `/dev` to browse stories.
// Manually list stories here. You can automate later with a Bun script.
import ButtonMeta from "@/components/ui/button.stories";
import JsonTreeMeta from "@shared/output/JsonTree.stories";
import JsonSchemaTreeMeta from "@shared/output/JsonSchemaTree.stories";
import HeadlessSchemaConfigFormMeta from "@shared/forms/HeadlessSchemaConfigForm.stories";
import LiquidViewerMeta from "@shared/ui/code/LiquidViewer.stories";

import JSONTableMeta from "@shared/json-table/JSONTable.stories";
import DevtoolsGuideMeta from "@modules/devtools/registry/devtools.docs.stories";
import CustomNodeMeta from "@flows/canvas/nodeTypes/CustomNode.stories";
import ExecEdgeMeta from "@flows/canvas/edgeTypes/ExecEdge.stories";
import CommandBarMeta from "@flows/palette/CommandBar.stories";
import NodeInspectorPanelMeta from "@flows/components/output/NodeInspectorPanel.stories";
import TypeInferenceMeta from "@flows/canvas/TypeInference.stories";
import ObjectValuesMeta from "@flows/canvas/ObjectValues.stories";
import JsonParseMeta from "@flows/canvas/JsonParse.stories";
import TupleOpsMeta from "@flows/canvas/TupleOps.stories";
import ShapePathMeta from "@flows/canvas/TypeInference.shapePath.stories";
import LiteralsAsConstMeta from "@flows/canvas/LiteralsAsConst.stories";

export const STORIES = [
  ButtonMeta,
  JsonTreeMeta,
  JsonSchemaTreeMeta,
  HeadlessSchemaConfigFormMeta,
  LiquidViewerMeta,
  JSONTableMeta,
  DevtoolsGuideMeta,
  CustomNodeMeta,
  ExecEdgeMeta,
  CommandBarMeta,
  NodeInspectorPanelMeta,
  TypeInferenceMeta,
  ObjectValuesMeta,
  JsonParseMeta,
  TupleOpsMeta,
  LiteralsAsConstMeta,
  ShapePathMeta,
];
